import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OnlinePaymentTransactionStatusModel } from 'src/app/model/OnlinePaymentTransactionStatusModel';

@Component({
  selector: 'app-secure-payment-reconciliation-modal',
  templateUrl: './payment-reconciliation-modal.component.html',
  styleUrls: ['./payment-reconciliation-modal.component.scss']
})
export class PaymentReconciliationModalComponent implements OnInit {
  obj: OnlinePaymentTransactionStatusModel;
  
  constructor(private modalCtrl: ModalController) { }

  ngOnInit(): void { }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }

}
